export default class GasflussDto {
  static get numberFormat() {
    return new Intl.NumberFormat('de-ch', {maximumFractionDigits: 1})
  }

  constructor(json) {
    this.json = json
    this.code = json.code
    this.translations = json.translations
    this.nominiert = this.format(json.nominiert)
    this.effektiv = json.effektiv === undefined ? "na" : this.format(json.effektiv)
    this.gebucht = this.format(json.gebucht)
    this.technisch = this.format(json.technisch)
    this.auslastung = this.format(json.auslastung * 100)
    this.bemerkung = json.bemerkung

    this.nominiertRaw = json.nominiert ?? 0
    this.auslastungRaw = json.auslastung ?? 0
  }

  format(num) {
    return num && !isNaN(num) ? GasflussDto.numberFormat.format(num) : '-'
  }

  get name() {
    return this.translations[getLanguage()]
  }
}
